import React, { useState } from "react";
import ApiService from "../../api/apiService";
import showSwal from "../swal";
import { common } from "../../util/common";

export const GLOBAL_SEARCH_PAGE_SIZE = 20;

function SearchInput({
  showSearchResults,
  hideSearchResults,
  isShowingSearchResults,
  setGlobalSearchResults,
  setGlobalSearchPagination,
  setIsGlobalSearchLoading,
  setHasGlobalSearchExecuted,
  setSearchQuery: mainSetSearchQuery,
}) {
  const [searchQuery, setSearchQuery] = useState("");
  const handleSearchInputChange = (e) => {
    const target = e.target;
    setSearchQuery(target.value);

    if (target.value.trim() === "") {
      setHasGlobalSearchExecuted(false);
      setGlobalSearchResults(null);
      mainSetSearchQuery("");
    }
  };

  const handleSearch = async () => {
    const keyword = searchQuery.trim();
    if (!keyword) {
      setHasGlobalSearchExecuted(false);
      setGlobalSearchResults(null);
      mainSetSearchQuery("");
      return;
    }

    setIsGlobalSearchLoading(true);
    setHasGlobalSearchExecuted(false);
    try {
      const searchResults = await ApiService.v3.message.globalSearchMessage({
        keyword,
        page: 1,
        limit: GLOBAL_SEARCH_PAGE_SIZE,
      });
      const { success, result, pagination } = searchResults;
      if (!success) {
        setGlobalSearchResults({ messages: [], conversations: [] });
        setGlobalSearchPagination({ page: 1, hasMore: false, totalMessages: 0 });
        showSwal(common.errors.GLOBAL_SEARCH_RESULT_ERROR);
      } else {
        setGlobalSearchResults(result || { messages: [], conversations: [] });
        setGlobalSearchPagination({
          page: 1,
          hasMore: !!pagination?.hasNextPage,
          totalMessages: pagination?.totalRecords ?? result?.messages?.length ?? 0,
        });
      }
      mainSetSearchQuery(keyword);
      setHasGlobalSearchExecuted(true);
      showSearchResults();
    } catch (error) {
      setGlobalSearchResults({ messages: [], conversations: [] });
      setGlobalSearchPagination({ page: 1, hasMore: false, totalMessages: 0 });
      mainSetSearchQuery(keyword);
      setHasGlobalSearchExecuted(true);
      showSwal(common.errors.GLOBAL_SEARCH_RESULT_ERROR);
    } finally {
      setIsGlobalSearchLoading(false);
    }
  };

  const handleBack = () => {
    setSearchQuery("");
    mainSetSearchQuery("");
    setGlobalSearchResults(null);
    setHasGlobalSearchExecuted(false);
    setIsGlobalSearchLoading(false);
    hideSearchResults();
  };
  return (
    <div className='search-input-container-header'>
      {isShowingSearchResults && (
        <div className='search-container-back' onClick={handleBack}>
          <i className='fa fa-arrow-left' aria-hidden='true'></i>
        </div>
      )}
      <div className='search-container'>
        <div className='search-icon-container'>
          <i className='fa fa-search' aria-hidden='true'></i>
        </div>
        <input
          type='text'
          className='search-input-header'
          placeholder='Search'
          onChange={(e) => handleSearchInputChange(e)}
          onFocus={showSearchResults}
          value={searchQuery}
          onKeyDown={(e) => {
            if (e.key === "Enter" && e.target.value.trim() !== "") {
              e.preventDefault();
              handleSearch();
            }
          }}
        />
      </div>
    </div>
  );
}
export default SearchInput;
